import { ChevronDown, ChevronUp, MapPin, User, Tag } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ContractReviewModal } from './contractReviewModal';
import { useState } from 'react';

export interface Project {
  id: string;
  name: string;
  address: string;
  homeowner: string;
  milestone: string;
  contract_url:any;
  status: 'Draft' | 'Pending Signature' | 'Live';
}

function ProjectCard({ project ,setIsrevierwModalOpen ,setSelectedproject}: { project: Project ,setIsrevierwModalOpen:any;setSelectedproject:any}) {
  const statusConfig = {
    'Draft': { 
      bg: 'bg-gray-50', 
      text: 'text-gray-700', 
      border: 'border-gray-200',
      accent: 'border-gray-300'
    },
    'Pending Signature': { 
      bg: 'bg-amber-50', 
      text: 'text-amber-700', 
      border: 'border-amber-200',
      accent: 'border-amber-300'
    },
    'Live': { 
      bg: 'bg-emerald-50', 
      text: 'text-emerald-700', 
      border: 'border-emerald-200',
      accent: 'border-emerald-300'
    }
  };

  const actionLabels = {
    'Draft': 'Continue Setup',
    'Pending Signature': 'View Contract',
    'Live': 'View Contract'
  };

  const config = statusConfig[project.status];
  const navigate = useNavigate()
  return (
    <div className={`project-card bg-white border-2 border-solid ${config.accent} rounded-xl p-6 hover:shadow-lg transition-all duration-200 hover:-translate-y-0.5`}>
      <div className="flex justify-between items-start mb-5">
        <div className="flex-1">
          <h3 className="text-lg font-[500] text-gray-900 mb-4 tracking-tight">{project.name}</h3>
          <div className="space-y-3">
            <div className="flex items-start gap-3 text-sm text-gray-700">
              <MapPin className="w-4 h-4 mt-0.5 text-gray-500 flex-shrink-0" />
              <span className="leading-relaxed">{project.address}</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <User className="w-4 h-4 text-gray-500 flex-shrink-0" />
              <span>{project.homeowner}</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <Tag className="w-4 h-4 text-gray-500 flex-shrink-0" />
              <span>{project.milestone}</span>
            </div>
          </div>
        </div>
        <span className={`px-3.5 py-2 rounded-xl  border-solid text-xs font-[500] border-2 ${config.bg} ${config.text} ${config.border}`}>
          {project.status}
        </span>
      </div>
      <div className="pt-4 grid gap-2  border-t border-solid border-l-0 border-b-0 border-r-0 border-gray-100">
        <button onClick={()=>{
  navigate(`/create-contract?tab=Project-Details&id=${project.id}`)

        }} className="w-full bg-indigo-600 border-0 hover:bg-indigo-700 active:bg-indigo-800 text-white py-3.5 px-4 rounded-xl font-[500] transition-all duration-200 shadow-sm hover:shadow-md transform hover:scale-[1.02] active:scale-100">
        {actionLabels[project.status]}
        </button>

{project?.contract_url &&  <button onClick={()=>{
 setIsrevierwModalOpen(true)
 setSelectedproject(project)
        }} className="w-full bg-white  border-1 border-gray-600 border-solid hover:bg-indigo-700 active:bg-indigo-800 text-gray-600 py-3.5 px-4 rounded-xl font-[500] transition-all duration-200 shadow-sm hover:shadow-md transform hover:scale-[1.02] active:scale-100">
      View Contract
        </button>}
       
      </div>
    </div>
  );
}

interface ActiveProjectsProps {
  projects?: Project[];
}

export function ActiveProjects({ projects }: ActiveProjectsProps) {

const [isReviewModalOpen,setIsrevierwModalOpen]= useState(false)
const [selectedproject,setSelectedproject] = useState<any >("")
const [showAllProjects, setShowAllProjects] = useState(false)
  const displayProjects = projects||[]
  const visibleProjects = showAllProjects ? displayProjects : displayProjects.slice(0, 3)
  const hiddenProjectCount = Math.max(0, displayProjects.length - visibleProjects.length)

  return (
    <div className="contractor-section contractor-projects-section">
      <div className="contractor-section__heading mb-6">
        <h2 className="text-xl font-[500] text-gray-900 tracking-tight">Recent Projects</h2>
        <p className="text-sm text-gray-600 mt-1">Your current workload</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibleProjects.map((project) => (
          <ProjectCard setIsrevierwModalOpen={setIsrevierwModalOpen}  setSelectedproject={setSelectedproject} key={project.id} project={project} />
        ))}
      </div>
      {displayProjects.length > 3 && (
        <button
          type="button"
          className="contractor-projects-section__toggle"
          onClick={() => setShowAllProjects((current) => !current)}
          aria-expanded={showAllProjects}
        >
          {showAllProjects ? <ChevronUp size={16} aria-hidden="true" /> : <ChevronDown size={16} aria-hidden="true" />}
          {showAllProjects ? 'Show fewer projects' : 'View all projects'}
          {!showAllProjects && <span>{hiddenProjectCount} more</span>}
        </button>
      )}
      <ContractReviewModal isOpen={isReviewModalOpen}
  onClose={()=>{
    setIsrevierwModalOpen(false)
  }}
  pdfUrl={selectedproject?.contract_url} />
    </div>
  );
}
